import { render, staticRenderFns } from "./VeranstalterDaten.vue?vue&type=template&id=76540b40&"
import script from "./VeranstalterDaten.vue?vue&type=script&lang=js&"
export * from "./VeranstalterDaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports